export default __webpack_public_path__ + "static/media/0xefee2de82343be622dcb4e545f75a3b9f50c272d.34a177c1.jpg";